import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
  mutation PasswordResetConfirmMutation($input: Session__PasswordResetConfirmInput!) {
    passwordResetConfirm(input: $input) {
      success
     error
    }
  }
`;

const commit = input =>
    createMutation({
        mutation,

        variables: {
            input
        }
    });

export default { commit };
